<template>
  <div class="addPage">
    <van-dialog
      v-model="showAddPage"
      title="新增评论"
      show-cancel-button
      @confirm="saveCommontValue"
      @close="closePicker"
      class="addcommontBox"
    >
      <div class="commontMain">
        <van-field
          v-model="commontValue"
          rows="3"
          autosize
          type="textarea"
          placeholder="请输入评论"
          show-word-limit
        />
        <p class="tit">添加图片</p>
        <div class="addBox clearfix">
          <van-row gutter="20" class="commentImgs clearfix fl">
            <van-col span="8" v-for="(imgItem,index) in listData" :key="imgItem.id">
              <van-image
                fit="contain"
                v-if="imgItem.url"
                :src="`${imgItem.url}`"
                @click="Showswiper(index)"
              />
              <van-icon name="close" class="delBtn" @click="setDelete(index,imgItem)" />
            </van-col>
            <van-col span="8">
              <div class="addImgs">
                <van-image fit="contain" :src="baseUrl+'addImg.png'" @click="addImgs" />
              </div>
            </van-col>
          </van-row>

          <!-- <li class="imgList lf" v-for="(imgItem,index) in listData" :key="imgItem.id">
              <van-image
                fit="contain"
                v-if="imgItem.url"
                :src="`${imgItem.url}`"
                @click="Showswiper(index)"
              />
              <van-icon name="close" class="delBtn" @click="setDelete(index,imgItem)" />
            </li>
          -->
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "addCommont",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showAddPage: true,
      forestObjId: "",
      oldtreeId: "",
      pageType: "",
      commontValue: "",
      backstagelists: [],
      listData: [],
      clientType: ""
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    window.setFile = this.setFiles;
    this.$nextTick(() => {
      this.pageType = this.addCommontType.pageType;
      if (this.pageType == "forest") {
        this.forestObjId = this.addCommontType.id;
      } else {
        this.oldtreeId = this.addCommontType.id;
      }
      console.log(this.forestObjId);
    });
  },
  methods: {
    saveCommontValue() {
      let _this = this;
      let contentData = {};
      contentData.comment = _this.commontValue;
      contentData.files = _this.listData.length < 1 ? null : _this.listData;
      if (_this.pageType == "forest") {
        contentData.objid = this.forestObjId;
      } else {
        contentData.treeId = this.oldtreeId;
      }

      _this.$api.universal
        .addCommont(_this.pageType, contentData)
        .then(res => {
          if (res.code == "1") {
            _this.$toast("添加评论成功");
            _this.$store.commit("setCallBackCommont", _this.pageType);
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    closePicker() {
      //关闭弹框将值清零
      let data = {
        type: false,
        pageType: this.pageType,
        id: ""
      };
      this.$store.commit("setAddCommontType", data);
    },
    Showswiper(showIndex) {
      let magnifyList = [];
      this.listData.forEach(SelectBigImgs);
      function SelectBigImgs(item, index) {
        magnifyList.push(item.url);
      }
      let data = {
        showImgs: magnifyList,
        swipercliclIndex: showIndex,
        swiperShow: true
      };
      this.$store.commit("setDataImgs", data);
    },
    //添加图片
    addImgs() {
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(102);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("1");
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      console.log(data);
      if (this.clientType == "android") {
        this.setImgs(data);
      } else {
        this.setImgs(JSON.parse(data));
      }
    },
    setImgs(item) {
      //上传图片
      let _this = this;
      let arr = [];
      _this.$toast("图片上传成功！");
      arr.push(item);
      this.listData = this.listData.concat(arr);
    },
    setDelete(index, item) {
      //删除上传的文件
      let _this = this;

      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除该图片吗？"
        })
        .then(() => {
          this.listData.splice(index, 1);
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  computed: {
    ...mapState(["addCommontType"])
  },
  watch: {
    addCommontType: {
      handler: function() {
        this.pageType = this.addCommontType.pageType;
        if (this.pageType == "forest") {
          this.forestObjId = this.addCommontType.id;
        } else {
          this.oldtreeId = this.addCommontType.id;
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
.addPage {
  .addcommontBox.van-dialog {
    padding: 0 8px;
    .van-dialog__header {
      padding-top: 15px;
    }
    .commontMain {
      .van-cell {
        padding: 8px 5px;
        border: 1px solid #f6f6f6;
        box-sizing: border-box;
      }
      .van-cell:not(:last-child)::after {
        content: initial;
      }
      .tit {
        font-size: 14px;
        padding-left: 5px;
        color: #999;
        margin: 5px 0;
      }
      .addBox {
        max-height: 205px;
        overflow-y: scroll;
      }
      .commentImgs {
        width: 100%;
        > .van-col {
          position: relative;
          margin: 10px 0;
          .van-image {
            max-width: 100%;
          }
          .delBtn {
            color: red;
            font-size: 16px;
            position: absolute;
            top: -8px;
            right: 2px;
            z-index: 100;
          }
        }
      }
      .addImgs {
        box-sizing: border-box;
        border: 1px solid #f6f6f6;
        height: 2.15rem;
        box-sizing: border-box;
        position: relative;
        .van-image {
          width: 100%;
          height: 100%;
          position: relative;
          img {
            max-width: 38px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
</style>